import {componentLoader, Loadable} from "@bounce/shared/helpers";
import {useAuth} from "@bounce/shared/contexts";
import {useScrollToTop} from "@bounce/shared/hooks";
import {consumerRoutes} from "./consumerRoutes";
import {consumerUrls} from "./consumerUrls";
import {lazy, useEffect} from "react";
import {Navigate, useLocation, useRoutes} from "react-router-dom";

const ErrorPage = Loadable(lazy(() => componentLoader(() => import("~/pages/error/ErrorPage"))));

const BackofficeRedirect = () => {
  const {pathname, search, hash} = useLocation();
  const backofficeUrl = import.meta.env.VITE_BACKOFFICE_URL;

  useEffect(() => {
    if (backofficeUrl) {
      window.location.replace(`${backofficeUrl}${pathname}${search}${hash}`);
    }
  }, []);

  if (!backofficeUrl) return <ErrorPage />;
  return null;
};

export default function Router() {
  const {loggedIn} = useAuth();
  useScrollToTop();

  return useRoutes([
    {
      path: "/",
      element: <Navigate to={loggedIn ? consumerUrls.accounts.url : consumerUrls.login.url} replace />,
    },
    ...consumerRoutes,
    {path: "backoffice/*", element: <BackofficeRedirect />},
    {path: "spring/*", element: <BackofficeRedirect />},
    {path: "*", element: <ErrorPage />},
  ]);
}
